let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === "undefined") return null;
  if (ctx) return ctx;
  const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  ctx = new Ctor();
  return ctx;
}

type Tone = "ok" | "warn" | "error";

const PROFILES: Record<Tone, { freq: number; duration: number; type: OscillatorType }> = {
  ok: { freq: 1080, duration: 0.09, type: "sine" },
  warn: { freq: 720, duration: 0.14, type: "square" },
  error: { freq: 220, duration: 0.22, type: "sawtooth" },
};

export function beep(tone: Tone = "ok"): void {
  const ac = getCtx();
  if (!ac) return;
  if (ac.state === "suspended") {
    void ac.resume();
  }
  const { freq, duration, type } = PROFILES[tone];
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.value = 0;
  gain.gain.setValueAtTime(0, ac.currentTime);
  gain.gain.linearRampToValueAtTime(0.12, ac.currentTime + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + duration);
  osc.connect(gain).connect(ac.destination);
  osc.start();
  osc.stop(ac.currentTime + duration + 0.02);
}

export function vibrate(pattern: number | number[]): void {
  if (typeof navigator === "undefined" || !navigator.vibrate) return;
  navigator.vibrate(pattern);
}
